<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" id="illustrations">
<div class="header">
<h3>List of Illustrations</h3>
</div>
<ol>
<li><a href="#/Text/Section0006">I arose in haste and, drawing the sword from under his head, dealt him a blow that made his head fall from his body. . . . Then she drew a sword . . . and threw herself thereon . . . and she fell to the ground dead</a><br/></li>
<li><span href="#/Text/Section0023" title="Link target outside of Sample">While they were thus enjoying themselves, lo! up came a damsel, trembling for fear and said, ‘O my Lady! The Commander of the Faithful’s eunuchs are at the door’</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?40eea01a